import type { Role } from './types.js';

/** The built-in, undeletable team every user belongs to. */
export const EVERYONE_TEAM_ID = 't_everyone';
export const EVERYONE_TEAM_NAME = 'Everyone';

export const ROLE_RANK: Record<Role, number> = { Admin: 3, Manager: 2, Member: 1 };

export const ROLES: Role[] = ['Admin', 'Manager', 'Member'];

/** Fixed 11-colour chart palette, keyed by a project's index. (data.jsx / dashboard.jsx) */
export const PROJECT_PALETTE = [
  '#FF5A3C',
  '#2563eb',
  '#7c3aed',
  '#0891b2',
  '#059669',
  '#d97706',
  '#db2777',
  '#475569',
  '#0d9488',
  '#e11d48',
  '#65a30d',
] as const;

/** Avatar background palette (initials hash). (components.jsx) */
export const AVATAR_PALETTE = [
  '#FF5A3C',
  '#2563eb',
  '#7c3aed',
  '#0891b2',
  '#059669',
  '#d97706',
  '#db2777',
  '#475569',
  '#0d9488',
  '#e11d48',
] as const;

export function projectColorIndex(projectId: string | null | undefined, orderedProjectIds: string[]): number {
  if (!projectId) return 0;
  const idx = orderedProjectIds.indexOf(projectId);
  return (idx < 0 ? 0 : idx) % PROJECT_PALETTE.length;
}

export function projectColor(projectId: string | null | undefined, orderedProjectIds: string[]): string {
  return PROJECT_PALETTE[projectColorIndex(projectId, orderedProjectIds)];
}

export const TIMEZONE = 'Europe/London';
